import { useEffect, useMemo, useCallback } from "react";
import { useSearchParams } from "./useSearchParams";

export type SortRule = { id: string; desc: boolean };

type ReturnType = [SortRule[], (rules: SortRule[]) => void];

export const useTableSorts = (initial: SortRule): ReturnType => {
  const [searchParams, setSearchParams] = useSearchParams();

  const sorts = useMemo(() => {
    const order = searchParams.get("order");
    const orderBy = searchParams.get("orderBy");

    return orderBy
      ? [{ id: orderBy, desc: order ? order === "desc" : false }]
      : [initial];
  }, [searchParams]);

  const updateSorts = useCallback(
    (rules: SortRule[]) => {
      const rule = rules?.[0];
      if (rule) {
        searchParams.set("order", rule.desc ? "desc" : "asc");
        searchParams.set("orderBy", rule.id);
      } else {
        searchParams.delete("order");
        searchParams.delete("orderBy");
      }

      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  useEffect(() => {
    updateSorts(sorts);
  }, [sorts, updateSorts]);

  return [sorts, updateSorts];
};
